/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Shot_ChangesInputs */

const en_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap to Shot Changes`)
};

const fr_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner sur les changements de plan`)
};

const de_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnappschuss-Änderungen`)
};

const it_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggancia alle modifiche di ripresa`)
};

const ru_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения при мгновенном переходе к кадру`)
};

const es_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios en la toma`)
};

const zh_cn2_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快照到拍摄变化`)
};

const ja_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの変更にスナップ`)
};

const hi_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तनों पर स्नैप करें`)
};

const pt_pt2_snap_to_shot_changes = /** @type {(inputs: Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações de disparo instantâneo`)
};

/**
* | output |
* | --- |
* | "Snap to Shot Changes" |
*
* @param {Snap_To_Shot_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes = /** @type {((inputs?: Snap_To_Shot_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_shot_changes(inputs)
	if (locale === "de") return de_snap_to_shot_changes(inputs)
	if (locale === "it") return it_snap_to_shot_changes(inputs)
	if (locale === "ru") return ru_snap_to_shot_changes(inputs)
	if (locale === "es") return es_snap_to_shot_changes(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_shot_changes(inputs)
	if (locale === "ja") return ja_snap_to_shot_changes(inputs)
	if (locale === "hi") return hi_snap_to_shot_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_shot_changes(inputs)
	return en_snap_to_shot_changes(inputs)
});